import FolderOutlined from "@mui/icons-material/FolderOutlined";
import PermMediaOutlined from "@mui/icons-material/PermMediaOutlined";
import { type TreeItemProps, TreeItem } from "@mui/x-tree-view";

export const CustomTreeItem = ({
  itemId,
  label,
  slotProps,
  ...rest
}: TreeItemProps): React.ReactElement => {
  const isRoot = itemId === "0";
  return (
    <TreeItem
      {...rest}
      itemId={itemId}
      slotProps={{
        ...slotProps,
        label: {
          ...slotProps?.label,
          style: { display: "flex", alignItems: "center", gap: 8 },
        },
      }}
      label={
        <>
          {isRoot ? <PermMediaOutlined fontSize="small" /> : <FolderOutlined fontSize="small" />}
          {label}
        </>
      }
    />
  );
};
